import { PillUnit, UnitQueueWireDto } from '@mark43/cad-api';
import { createContext } from 'react';
import {
    BoloQueueRowData,
    HospitalQueueRowData,
    ScheduledEventQueueRowData,
} from '../../socket/stream-types';
import { ContextMenuKind } from '../../context-menus/types';

type ContextMenuState =
    | {
          kind: Extract<ContextMenuKind, 'EVENT' | 'UNIT'>;
          entityId: number;
      }
    | {
          kind: Extract<ContextMenuKind, 'HELD_UNIT'>;
          data: PillUnit;
      }
    | {
          kind: Extract<ContextMenuKind, 'MULTI_UNIT'>;
          data: PillUnit[];
      }
    | {
          kind: Extract<ContextMenuKind, 'UNIT_TIMER'>;
          data: UnitQueueWireDto;
      }
    | {
          kind: Extract<ContextMenuKind, 'SCHEDULED_EVENT'>;
          data: ScheduledEventQueueRowData;
      }
    | {
          kind: Extract<ContextMenuKind, 'HOSPITAL'>;
          data: HospitalQueueRowData;
      }
    | {
          kind: Extract<ContextMenuKind, 'BOLO'>;
          data: BoloQueueRowData;
      };

export type ContextMenuWriteContextValue = (state: ContextMenuState | undefined) => void;
export const ContextMenuWriteContext = createContext<ContextMenuWriteContextValue | undefined>(
    undefined
);

export type ContextMenuReadContextValue = ContextMenuState | undefined;
export const ContextMenuReadContext = createContext<ContextMenuReadContextValue>(undefined);
